import React, {memo, useContext} from 'react';
import './SelectLocation.less';
import {LocationList} from "compositions/location-list/LocationList";
import {Card} from "elements/card/Card.tsx";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import sortBy from "lodash/sortBy";
import {getDistanceFromLatLonInKm} from "helpers/geolocation.helper";
import {getSafeTranslation} from "../../../helpers/localization.helper";
import GeolocationIcon from "new-images/geolocation.svg";
import {TranslationsContext} from "contexts/translations-context";
import {PermissionRequest} from "../../compositions/permission-request/PermissionRequest";
import {CardStyles} from "../../elements/card/Card";

export const SELECT_LOCATION_POPUP = 'SELECT_LOCATION_POPUP';
export const CART_SELECT_LOCATION_POPUP = 'CART_SELECT_LOCATION_POPUP';

function getRestaurantsSortedByDistance(restaurants, currentLocation = null) {
	if (currentLocation?.latitude && currentLocation?.longitude) {
		return sortBy(restaurants, restaurant => {
			return getDistanceFromLatLonInKm(
				currentLocation.latitude,
				currentLocation.longitude,
				restaurant.latitude,
				restaurant.longitude
			);
		});
	}

	return restaurants;
}

export const SelectLocation = memo(({
																			currentPosition,
																			locations,
																			orderingType,
																			isShowLocationPermissionRequest,
																			onLocationPermissionRequestClick,
																			onLocationClick,
																			onOverlayClick
																		}) => {

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('SelectLocationPopup.title', translations)}
		description={isShowLocationPermissionRequest ? getSafeTranslation('LocationPermissionConfirmationPopup.description', translations) : null}
		headerBottomControl={isShowLocationPermissionRequest && locations.length > 1 && (
			<PermissionRequest
				icon={GeolocationIcon}
				text={getSafeTranslation('SelectLocationPopup.permissionButtonCaption', translations)}
				onClick={onLocationPermissionRequestClick}
			/>
		)}
		bottom
		onOverlayClick={onOverlayClick}
	>
		<div className="select-location">
			<Card style={CardStyles.NESTED} isNoPaddings>
				<LocationList
					locations={getRestaurantsSortedByDistance(locations, currentPosition)}
					orderingType={orderingType}
					onLocationClick={onLocationClick}
				/>
			</Card>
		</div>
	</DrawerPopup>
})
